/**
 * Offer data for the Manly funnel.
 *
 * THE FUNNEL SELLS ONE PRODUCT: the Natural Body Wash. Bundles (Duo Set, Full
 * Tactical Kit) are deliberately out of scope, so nothing in here names, routes
 * to or recommends a kit, and no funnel copy may promise a deodorant. The old
 * three-tier kit routing (essential / buffer / fullKit) was removed with it.
 *
 * NO PRICE IS RENDERED ANYWHERE IN THE FUNNEL, by design, so no price lives
 * here. Manly's pricing moves underneath us (site-wide sales, a subscription
 * discount, per-region currency), and we cannot show a parent a number we can't
 * stand behind. The CTA hands off to the live offer page, which is the single
 * source of truth for price and discount.
 */
export const OFFER = {
  product: {
    name: "Manly Natural Body Wash",
    copy: "One bottle, in the shower he already takes. Kakadu Plum kills the odor-causing bacteria instead of covering them.",
  },
  // Verified on the PDP, 2026-08-13: "Covered by our 60-Day Money Back
  // Guarantee." Mirrors usemanly.com rather than inventing a term.
  guarantee: {
    lead: "No B.O. or money back.",
    detail: "60 days, any reason. Not 30. Not 14. Sixty.",
  },
  // Both the product link and the funnel's exit. THE FIX's "Claim my discount"
  // CTA sends here after the discount-applying loader.
  //
  // The GWP offer page, not the bare PDP: it is the surface that actually
  // carries the discount the loader just promised (quantity tiers + free
  // gifts), so "Claim my discount" lands on a discount instead of on list
  // price. Checked 2026-08-19 — it sells the body wash by the bottle (1/2/3/4
  // soaps) and names no deodorant, Duo Set or Tactical Kit, so it still honours
  // the funnel's body-wash-only promise. That is also why it is NOT the old
  // /pages/teen-g advertorial, whose offer IS the kit.
  //
  // Named pdpHref for symmetry with the sibling Endocrine quiz's OFFER; it is a
  // landing page now, not a PDP.
  pdpHref: "https://usemanly.com/pages/Gwp-mof",
} as const;
